import { useQuery } from '@tanstack/react-query';
import { MaintenanceExecutionService } from '~/app/services/maintenance-execution/maintenance-execution.service';

export const workOrderBoardQueryKey = (organizationId: string) =>
  [
    'maintenance-execution',
    'board',
    'v6-incident-resolve',
    organizationId,
  ] as const;

export function useWorkOrderBoard(organizationId: string) {
  return useQuery({
    queryKey: workOrderBoardQueryKey(organizationId),
    queryFn: () => MaintenanceExecutionService.getBoard({ organizationId }),
    enabled: Boolean(organizationId),
  });
}
